<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";

// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}

// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      tableData: [],
      title: "送信履歴",
      items: [
        {
          text: "Mail",
          href: "/",
        },
        {
          text: "送信履歴",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 25, 50, 100],
      send_date: {
        date: "",
        time: "",
      },
      send_count: 0,
      mail_title: "",
      mail_detail: "",
      id: null,
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: [
        "send_date_",
        "send_count",
        "mail_title",
        "mail_detail"
      ],
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "send_date_",
          label: "送信日",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "send_count",
          label: "送信数",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "mail_title",
          label: "タイトル",
          sortable: true,
          tdClass: "minWidth200",
        },
        {
          key: "mail_detail",
          label: "詳細",
          sortable: true,
          tdClass: "minWidth300",
        },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      mode: "list",
      recipientOptions: [],
      selectedRecipients: [],
    };
  },
  mounted() {
    this.searchItems();
  },
  computed: {
    rows() {
      return this.filterItems.length;
    },
  },
  methods: {
    // 一覧取得
    searchItems() {
      this.loading = true;
      axios
        .get("/api/mail_histories")
        .then((response) => {
          this.loading = false;
          this.tableData = response.data.map((item) => {
            return {
              ...item,
              send_date_: item.send_date_,
              mail_title: item.title,
              mail_detail: item.detail,
            };
          });
          this.filterItems = this.tableData;
          this.selectAll = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      console.log(ids);
      axios
        .post("/api/mail_histories/delete", { ids: ids })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 追加
    add() {
      this.mode = "add";
      this.id = "new";
      this.send_date = {
        date: "",
        time: "",
      };
      this.send_count = 0;
      this.mail_title = "";
      this.mail_detail = "";
    },
    // 編集
    edit(item) {
      this.mode = "edit";
      this.id = item.id;
      this.send_date = {
        date: item.send_date.split(" ")[0],
        time: item.send_date.split(" ")[1],
      };
      this.send_count = item.send_count;
      this.mail_title = item.mail_title;
      this.mail_detail = item.mail_detail;

      // 送信先一覧を取得
      this.fetchSendList(item.id);
    },
    // 送信先一覧を取得
    fetchSendList(mailHistoryId) {
      this.loading = true;
      axios
        .get(`/api/mail_histories/${mailHistoryId}/send_list`)
        .then((response) => {
          this.loading = false;
          this.recipientOptions = response.data.map((recipient) => {
            return {
              value: recipient.id,
              text: `${recipient.school_name} 高校　${recipient.name} 様 <${recipient.email}>`,
            };
          });
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 確定
    submit() {
      let formData = {
        id: this.id,
        send_date: `${this.send_date.date} ${this.send_date.time}`,
        send_count: this.send_count,
        title: this.mail_title,
        detail: this.mail_detail,
      };
      this.loading = true;
      axios
        .post("/api/mail_histories/update", formData)
        .then((res) => {
          this.loading = false;
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      this.filterItems = items;
    },
  },
  watch: {
    selectAll: function (newValue, oldValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
  },
};
</script>
<style>
.flex {
  display: flex;
}

.box {
  width: 60px;
  flex-shrink: 0;
}

.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}

.minWidth300 {
  min-width: 300px;
  word-break: break-all;
}

.right {
  text-align: right;
}

.colorRed {
  color: red;
}

.table-hover tbody tr .colorRed {
  color: red;
}

.table-hover tbody tr:hover .colorRed {
  color: red;
}

.modal-mask {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="fields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span><button class="btn btn-sm btn-outline-primary" @click="edit(item)">
                      詳細
                    </button></span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete>
                    削除
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 編集 -->
    <div class="row" v-if="mode == 'edit'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">詳細</h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <!-- 送信日時 -->
                    <b-form-group label="送信日時" label-cols-sm="3">
                      <ValidationProvider name="送信日時" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <div class="d-flex align-items-center">
                            <b-form-input type="date" style="width: 150px; margin-right: 10px;" v-model="send_date.date"
                              autocomplete="off" disabled></b-form-input>
                            <b-form-input type="time" style="width: 150px;" v-model="send_date.time" autocomplete="off"
                              disabled></b-form-input>
                          </div>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <!-- 送信先一覧 -->
                    <b-form-group label="送信先一覧" label-cols-sm="3">
                      <div class="d-flex align-items-end">
                        <b-form-select v-model="selectedRecipients" :options="recipientOptions"
                          class="form-select mb-2 flex-grow-1" multiple disabled></b-form-select>
                      </div>
                    </b-form-group>
                    <!-- メールタイトル -->
                    <b-form-group label="タイトル" label-cols-sm="3">
                      <ValidationProvider name="タイトル" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="text" v-model="mail_title" autocomplete="off" disabled></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <!-- メール詳細 -->
                    <b-form-group label="詳細" label-cols-sm="3">
                      <ValidationProvider name="詳細" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-textarea v-model="mail_detail" rows="10" style="width: 100%;"
                            disabled></b-form-textarea>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid" @click="submit">
                      確定
                    </b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" mail_title="確認" mail_title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
